@if (accessToken()) {
  @if (machine) {
    <div class="rdv-container">
      <claas-rdv-client
        [accessToken]="accessToken()"
        [machineId]="machine"
        [showStatusMassagesInComponent]="true"
        [showProtocol]="showProtocol()"
        [tabbedView]="true"
        [showFullscreenButton]="showFullscreenButton"
        [autoConnect]="autoConnect"
        [clientInfo]="clientInfo"
        (statusChanged)="onStatusChanged($event)"></claas-rdv-client>
    </div>
  } @else {
    <div class="message-container">
      <p>No machine provided. Please provide a valid machine id to view the remote display.</p>
    </div>
  }
} @else {
  <div class="message-container">
    <p>No access token provided. Please provide a valid access token to view the remote display.</p>
  </div>
}
